/**
 * Converts string to snake case
 * @param {string} str
 */
export var snakeCase = function snakeCase(str) {
  return str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  });
};